export interface PageMeta {
  pageType: string
  category: string
  keywords: string
  title: string
  description: string
  author: string
  section: string
  tags: string[]
  contentTier: string
  searchQuery: string
}

function getMeta (name: string): string {
  try {
    var el = document.querySelector('meta[name="' + name + '"], meta[property="' + name + '"]')
    return el ? (el.getAttribute('content') || '') : ''
  } catch (e) { return '' }
}

function getMetaAll (name: string): string[] {
  try {
    var els = document.querySelectorAll('meta[name="' + name + '"], meta[property="' + name + '"]')
    var result: string[] = []
    for (var i = 0; i < els.length; i++) {
      var val = els[i].getAttribute('content')
      if (val) result.push(val)
    }
    return result
  } catch (e) { return [] }
}

function detectPageType (path: string): string {
  var patterns: [RegExp, string][] = [
    [/\/(article|story|post|blog|news|analysis|wiretap)\//i, 'article'],
    [/\/(category|topic|section|tag)\//i, 'category'],
    [/\/(search|find|results)\b/i, 'search'],
    [/\/(player|team|scores|standings|stats|trade)\//i, 'article'],
    [/\/(product|item|listing)\//i, 'product'],
  ]
  for (var i = 0; i < patterns.length; i++) {
    if (patterns[i][0].test(path)) return patterns[i][1]
  }
  if (path === '/' || path === '') return 'homepage'
  return ''
}

function parseLdJson (): Partial<PageMeta> | null {
  try {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]')
    if (!scripts.length) return null
    var limit = Math.min(scripts.length, 5)
    for (var i = 0; i < limit; i++) {
      try {
        var text = scripts[i].textContent
        if (!text) continue
        var data = JSON.parse(text)
        var entries = Array.isArray(data) ? data : (data['@graph'] && Array.isArray(data['@graph'])) ? data['@graph'] : [data]
        for (var j = 0; j < entries.length; j++) {
          var entry = entries[j]
          if (!entry || typeof entry !== 'object') continue
          var type = (entry['@type'] || '').toLowerCase()
          if (type === 'article' || type === 'newsarticle' || type === 'blogarticle' || type === 'blogposting' || type === 'newsposting') {
            var result: Partial<PageMeta> = { pageType: 'article' }
            if (entry.articleSection) result.section = String(entry.articleSection)
            if (entry.about && entry.about.name) result.category = String(entry.about.name)
            if (typeof entry.keywords === 'string') result.keywords = entry.keywords
            if (Array.isArray(entry.keywords)) result.keywords = entry.keywords.join(', ')
            if (entry.author) {
              if (typeof entry.author === 'string') result.author = entry.author
              else if (Array.isArray(entry.author)) result.author = entry.author.map(function (a: any) { return a && a.name ? a.name : '' }).filter(Boolean).join(', ')
              else if (entry.author.name) result.author = String(entry.author.name)
            }
            if (entry.isAccessibleForFree === false) result.contentTier = 'paid'
            else if (entry.isAccessibleForFree === true) result.contentTier = 'free'
            return result
          }
        }
      } catch (e) { continue }
    }
    return null
  } catch (e) { return null }
}

export function scrapePageMeta (): PageMeta {
  var meta: PageMeta = {
    pageType: '',
    category: '',
    keywords: '',
    title: '',
    description: '',
    author: '',
    section: '',
    tags: [],
    contentTier: '',
    searchQuery: '',
  }

  try {
    meta.title = getMeta('og:title') || (document.title || '')
    meta.description = getMeta('og:description') || getMeta('description')
    meta.author = getMeta('author') || getMeta('article:author')
    meta.section = getMeta('article:section')
    meta.keywords = getMeta('keywords')
    meta.tags = getMetaAll('article:tag')
    var ogType = getMeta('og:type')
    if (ogType === 'article') meta.pageType = 'article'

    var ld = parseLdJson()
    if (ld) {
      if (ld.pageType && !meta.pageType) meta.pageType = ld.pageType
      if (ld.category && !meta.category) meta.category = ld.category
      if (ld.keywords && !meta.keywords) meta.keywords = ld.keywords
      if (ld.author && !meta.author) meta.author = ld.author
      if (ld.section && !meta.section) meta.section = ld.section
      if (ld.contentTier) meta.contentTier = ld.contentTier
    }

    var path = window.location.pathname
    if (!meta.pageType) meta.pageType = detectPageType(path)

    try {
      var params = new URLSearchParams(window.location.search)
      meta.searchQuery = params.get('q') || params.get('query') || params.get('search') || params.get('s') || ''
    } catch (e) {}

    if (meta.keywords && meta.keywords.length > 500) {
      meta.keywords = meta.keywords.substring(0, 500)
    }
  } catch (e) {}

  return meta
}
